import axios from 'axios'
const API_URL = process.env.API_URL || 'https://amenities.metroservices.io'
const $axios = axios.create({
  baseURL: API_URL,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'Authorization': window.localStorage.getItem('token')
  }
})
$axios.interceptors.request.use(function (config) {
  config.headers = {
    'Authorization': window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
  }
  return config
}, function (error) {
  return Promise.reject(error)
})
export default $axios



// WEBPACK FOOTER //
// ./src/backend/vue-axios/axios.js